import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  outlineColor: PropTypes.string.isRequired,
};

const OutlineColorIndicator = ({ backgroundColor, outlineColor }) => {
  return (
    <div
      className="rounded-full h-full w-full p-1"
      style={{ backgroundColor: backgroundColor }}
    >
      <div
        className="rounded-full h-full w-full border-2"
        style={{ borderColor: outlineColor }}
      />
    </div>
  );
};

OutlineColorIndicator.propTypes = propTypes;

export default OutlineColorIndicator;
